import { gql } from '../../../../hooks'

export const GET_INSPECTION_INFO = gql`
  query InspectionInfo($id: ID!) {
    i2InspectionInfo(id: $id) {
    }
  }
`
